import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ChapterCards from './components/ChapterCards';
import NikeDesign from './components/NikeDesign';

const useStyles = makeStyles(theme => ({
  root: { flexGrow: 1, display: 'flex', backgroundColor: '#1e1e1e' },
  content: { flexGrow: 1, backgroundColor: '#1e1e1e', padding: theme.spacing(3), marginTop: 60 },
}));
export default function CardsForBlogs({ in_json = [], title, description, image }) {
  const classes = useStyles();
  return <div className={classes.root}><main className={classes.content}>
    <NikeDesign blogCards={[<ChapterCards key="chapters" entries={in_json} />]} title={title} description={description} image={image} />
  </main></div>;
}
